<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/23yjHm/tc-custom/9780813139708.jpg?1704717799589" alt="This image is the cover for the book Homer Simpson Marches on Washington"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Homer Simpson Marches on Washington
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A volume of enlightening essays on how TV shows, movies, and music can change hearts and minds.</b><br/>  <br/> Amid all its frenetic humor, the long-running animated hit <i>The Simpsons</i> has often questioned what is culturally acceptable, wading into controversial subjects like gay rights, the war on terror, religion, and animal rights. This subtle form of political analysis is effective in changing opinions and attitudes on a large scale. <i>Homer Simpson Marches on Washington</i> explores the transformative power that enables popular culture to influence political agendas, frame the consciousness of audiences, and create profound shifts in values and ideals.<br/>  <br/> To investigate the full spectrum of popular culture in a democratic society, editors Timothy M. Dale and Joseph J. Foy gather a top-notch team of scholars who use television shows such as <i>Star Trek</i>, <i>The X-Files</i>, <i>All in the Family</i>, <i>The View</i>, <i>The Daily Show</i>, and <i>The Colbert Report</i>, as well as movies and popular music, to investigate contemporary issues in American popular culture.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Timothy M. Dale, Joseph J. Foy, Kate Mulgrew
      </h2>
      
      <p class="authorDescription body article">Timothy M. Dale, assistant professor of political science at the University ofWisconsin–Green Bay, is coauthor of Political Thinking, Political Theory, and Civil Society. He lives in Green Bay, Wisconsin.Joseph J. Foy, assistant professor of political science at the University of Wisconsin–Waukesha, is the editor of Homer Simpson Goes to Washington: American Politics through Popular Culture. He lives in Waukesha, Wisconsin.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?95325dac